<template>
  <div class="director-main-board">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="card cardcontents">
          <div class="card-header">
            안전사고현황
            <!-- <div class="accidentMove card-more" @click="goPage('안전사고 현황','/sop/iim/status/accidentStatus.vue',[],'02,05,07')"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div> -->
            <div class="card-more main-header-input">
              <c-datepicker
                type="year"
                default="today"
                name="occurYear"
                v-model="occurYear"
                @datachange="getYearList"
              />
            </div>          
          </div>
          <div class="card-body">
            <apexchart 
              ref="yearOcuurChart" 
              height="179px" 
              type="bar"
              @dataPointSelection="selectedBaryearOcuurChart"
              :options="yearOcuurChart.chartOptions" 
              :series="yearOcuurChart.series"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="padding-right: 0rem !important">
        <div class="card cardcontents">
          <div class="card-header">
            (금일) 안전작업허가 현황
            <div class="card-more card-more-txt" @click="goPageMap(plantCd2)">MAP보기</div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                name="plantCd2"
                :isFirstValue="false"
                label=""
                v-model="plantCd2"
                @datachange="getWorkPermits" />
            </div>
          </div>
          <div class="card-body nopadgrid">
            <c-table
              ref="grid1"
              tableId="grid1"
              :isTitle="false"
              :isDashboard="true"
              :columnSetting="false"
              :usePaging="false"
              :filtering="false"
              :isFullScreen="false"
              :hideBottom="true"
              gridHeight="192px"
              :columns="grid1.columns"
              :data="grid1.data"
              @rowClick="grid1Click"
            >
            </c-table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            대기자가측정 추이분석(내부/법적 기준)
            <!-- <div class="card-more" @click="goPage('대기 자가측정 추이분석','/env/air/selfAirMeasureGraph.vue', measureYear)"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div> -->
            <!-- <div class="card-more main-header-input">
              <c-select
                :comboItems="airComboItems"
                type="search"
                itemText="codeName"
                itemValue="code"
                name="airInspectTypeCd"
                v-model="airInspectTypeCd"
                @datachange="getAirchart"
              ></c-select>
            </div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                label=""
                name="plantCd5"
                v-model="plantCd5"
                @datachange="getAirchart" />
            </div> -->
            <div class="card-more main-header-input">
              <c-datepicker
                type="year"
                default="today"
                name="measureYear"
                v-model="measureYear"
                @datachange="getAirchart"
              />
            </div>
          </div>
          <div class="card-body">
            <apexchart 
              ref="airChart" 
              height="220px" 
              type="bar"
              :width="airChart.chartWidth"
              :options="airChart.chartOptions" 
              :series="airChart.series"
              @dataPointSelection="selectedBar"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="padding-right: 0rem !important">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            {{wasteTitle}}
            <div class="card-more card-more-txt" @click="goPage('폐기물 원단위 추이분석','/env/waste/wasteUCGraph.vue', wasteYear, '06')">상세보기</div>
            <div class="card-more main-header-input2">
              <c-select
                :comboItems="wasteComboItems"
                type="none"
                itemText="codeName"
                itemValue="code"
                name="wasteCode"
                v-model="wasteCode"
                @datachange="getWasteList"
              ></c-select>
            </div>
            <div class="card-more main-header-input2">
              <c-select
                v-if="wasteCode == '1'"
                :comboItems="wasteComboItems2"
                type="none"
                itemText="envWasteMstName"
                itemValue="envWasteMstId"
                name="envWasteMstId"
                v-model="envWasteMstId"
                @datachange="getWasteList"
              ></c-select>
            </div>
            <div class="card-more main-header-input2">
              <c-datepicker
                type="year"
                default="today"
                name="wasteYear"
                @input="getWasteList"
                v-model="wasteYear"
              />
            </div>
          </div>
          <div class="card-body">
            <apexchart 
              ref="wasteChart" 
              height="220px" 
              type="bar"
              :options="wasteChart.chartOptions" 
              :series="wasteChart.series"></apexchart>
          </div>
        </div>
      </div>
      <!-- <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" style="padding-right: 0rem !important">
        <div class="card cardcontents">
          <div class="card-header">
            (금년) 교육과정별 이수자/대상자
            <div class="card-more" @click="goPage('연간 교육 추이분석(그래프)','/sop/edu/annualEducationTrendAnalysisGraph.vue', plantCd6)"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                name="plantCd6"
                :isFirstValue="false"
                label=""
                v-model="plantCd6"
                @datachange="getEduAttendees" />
            </div>
          </div>
          <div class="card-body" style="height:211px">
            <div class="row">
              <div v-for="(attend, idx) in eduAttendees" 
                :key="idx" style="margin-left: 5px; margin-bottom:5px">
                <q-chip square color="white" :clickable="true" text-color="grey-9" @click="eduClick(attend.eduCourseId)">
                  <q-avatar :icon="getEduIcon(attend.educationKindCdLarge)" :color="getEduColor(attend.educationKindCdLarge)" text-color="white">
                    <q-tooltip class="bg-red" anchor="center left" self="center right" :offset="[10, 10]">{{attend.educationKindCdLargeName}}</q-tooltip>
                  </q-avatar>
                  {{attend.educationCourseName}}
                  <div class="attendBoxCnt" v-text="attend.checkCompleteCnt + '명 / ' + attend.checkAllCnt + '명'"></div>
                </q-chip>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            통합개선 이행율 현황
            <div class="card-more card-more-txt" @click="goPage('개선목록','/main/indexImpr.vue', imprYear)">상세보기</div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                label=""
                :isFirstValue="false"
                name="plantCd4"
                v-model="plantCd4"
                @datachange="getImprStatus" />
            </div>
            <div class="card-more main-header-input">
              <!-- default="today" -->
              <c-datepicker
                type="year"
                default="today"
                name="imprYear"
                @input="getImprStatus"
                v-model="imprYear"
              />
            </div>
          </div>
          <div class="card-body row">
            <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <apexchart 
                ref="imprChart" 
                height="400px" 
                type="bar"
                :options="imprChart.chartOptions" 
                :series="imprChart.series"
                @dataPointSelection="(event, chartContext, opts) => selectedBarImp(event, chartContext, opts, 'SAFETYHEALTH')"/>
            </div> -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <apexchart 
                ref="imprChart2" 
                height="300px" 
                type="bar"
                :options="imprChart2.chartOptions" 
                :series="imprChart2.series"
                @dataPointSelection="(event, chartContext, opts) => selectedBarImp(event, chartContext, opts, 'SAFETYHEALTH')"/>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <apexchart 
                ref="imprChart1" 
                height="300px" 
                type="bar"
                :options="imprChart1.chartOptions" 
                :series="imprChart1.series"
                @dataPointSelection="(event, chartContext, opts) => selectedBarImp(event, chartContext, opts, 'ENV')"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            교육과정별 완료현황
            <div class="card-more card-more-txt" @click="goPage('교육 수강인원 추이분석','/sop/edu/annualEducationTrendAnalysisGraph.vue', eduYear)">상세보기</div>
            <div class="card-more main-header-input">
              <!-- default="today" -->
              <c-datepicker
                type="year"
                default="today"
                name="eduYear"
                @input="getEduList"
                v-model="eduYear"
              />
            </div>
          </div>
          <div class="card-body">
            <apexchart 
              ref="eduChart" 
              height="615px" 
              type="bar"
              @dataPointSelection="selectedBarEdu"
              :width="eduChart.chartWidth"
              :options="eduChart.chartOptions" 
              :series="eduChart.series"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import selectConfig from '@/js/selectConfig';
export default {
  name: 'main-dashboard-director',
  components: { 
    apexchart: VueApexCharts
  },
  props: {
  },
  data() {
    return {
      popupOptions: {
        isFull: false,
        width: '90%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      envWasteMstId: 'EWMI000001',
      plantCd1: null,
      plantCd2: null,
      plantCd3: null,
      plantCd4: null,
      plantCd5: null,
      plantCd6: '02',
      wasteYear: '',
      wasteCode: '1',
      measureYear: '',
      eduAttendees: [],
      wasteTitle: '폐기물처리 추이분석',
      airInspectTypeCd: null,
      wasteComboItems: [
        { code: '1', codeName: '폐기물처리량' },
        { code: '2', codeName: '폐기물처리비용' },
        { code: '3', codeName: '폐기물매각수익' },
      ],
      airComboItems: [
        { code: 'AITC000001', codeName: '특정대기유해물질' },
        { code: 'AITC000002', codeName: '대기오염물질' },
      ],
      yearOcuurChart: {
        chartOptions: {
          title: {
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [], 
          },
          yaxis: {
            title: {
              text: ''
            }
          },
          fill: {
            opacity: 1,
            colors: ['#FFC107', '#00BCD4', '#F44336', '#fc97fc', '#0f0c01', '#30f090']
          },
          colors: ['#FFC107', '#00BCD4', '#F44336', '#fc97fc', '#0f0c01', '#30f090'],
          tooltip: {
            y: {
              formatter: function (val) {
                return val + "건"
              }
            },
            // custom: function({series, seriesIndex, dataPointIndex, w}) {
            //   return '<div class="arrow_box">' +
            //     '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
            //     '</div>'
            // }
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [],
        chartWidth: '100%',
      },
      imprChart1: {
        chartOptions: {
          title: {
            text: '환경팀'
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            hideOverflowingLabels: false,
            enabled: true,
            formatter: function(val) {
              return val !== 0 ? val : ''
            },
            style: {
              fontSize: '12px',
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: ['#0A6847', '#00BCD4', '#F44336',],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10,
            // customLegendItems: ['조치중', '개선완료(총합)', '지연 건수'],
          },
        },
        series: [],
        chartWidth: '100%',
      },
      imprChart2: {
        chartOptions: {
          title: {
            text: '안전보건팀'
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded',
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            hideOverflowingLabels: false,
            enabled: true,
            formatter: function(val) {
              return val !== 0 ? val : ''
            },
            style: {
              fontSize: '12px',
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: ['#0A6847', '#00BCD4', '#F44336',],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10,
            // customLegendItems: ['조치중', '개선완료(총합)', '지연 건수'],
          },
        },
        series: [],
        chartWidth: '100%',
      },
      airChart: {
        chartOptions: {
          title: {
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded',
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [], // 교육과정
          },
          yaxis: {
            title: {
              text: ''
            }
          },
          fill: {
            opacity: 1,
            colors: ['#1E90FF', '#F44336']
          },
          colors: ['#1E90FF', '#F44336'],
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [{
          name: '내부기준 초과',
          // data: [0, 0, 0, 0, 0]
          data: []
        }, {
          name: '법적기준 초과',
          // data: [0, 0, 0, 0, 0]
          data: []
        }],
      },
      eduChart: {
        chartOptions: {
          title: {
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
          },
          xaxis: {
            // categories: [], // 교육과정
            labels: {
              rotate: -90,
              rotateAlways: true,
              formatter: function(val) {
                return val ? String(val).substring(0, String(val).indexOf(',')) : ''
              },
              style: {
                fontSize: '11px',
                fontWeight: 500
              },
            },
            group: {
              style: {
                fontSize: '13px',
                fontWeight: 700
              },
              groups: []
            }
          },
          yaxis: {
            title: {
              text: ''
            }
          },
          fill: {
            opacity: 1,
            // colors: ['#1E90FF', '#F44336', '#0A6847', '#1E90FF', '#F44336', '#0A6847', '#1E90FF', '#F44336', '#0A6847']
          },
          colors: ['#1E90FF', '#F44336', '#0A6847', '#1E90FF', '#F44336', '#0A6847', '#1E90FF', '#F44336', '#0A6847'],
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            },
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10,
            customLegendItems: ['완료', '미완료', '진행중'],
          },
        },
        series: [
          {
            name: '완료',
            data: []
          }, 
          {
            name: '미완료',
            data: []
          }, 
          {
            name: '진행중',
            data: []
          }, 
          // {
          //   group: 'sh',
          //   name: '[안전보건]완료',
          //   data: []
          // }, 
          // {
          //   group: 'sh',
          //   name: '[안전보건]미완료',
          //   data: []
          // },
          // {
          //   group: 'sh',
          //   name: '[안전보건]진행중',
          //   data: []
          // },
          // {
          //   group: 'e',
          //   name: '[환경]완료',
          //   data: []
          // }, 
          // {
          //   group: 'e',
          //   name: '[환경]미완료',
          //   data: []
          // },
          // {
          //   group: 'e',
          //   name: '[환경]진행중',
          //   data: []
          // },
          // {
          //   group: 'o',
          //   name: '[기타]완료',
          //   data: []
          // }, 
          // {
          //   group: 'o',
          //   name: '[기타]미완료',
          //   data: []
          // },
          // {
          //   group: 'o',
          //   name: '[기타]진행중',
          //   data: []
          // },
        ],
      },
      wasteChart: {
        chartOptions: {
          chart: {
            type: 'line',
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false
          },
          title: {
            text: undefined,
            align: 'right',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: true,
            style: {
              fontSize:  '12px',
              color:  '#747474'
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          stroke: {
            width: [3,3,3,3,3,3,3,3],
            curve: 'straight',
          },
          xaxis: {
            categories: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
          },
          fill: {
            opacity: 1
          },
        },
        series: [],
        chartWidth: '100%',
      },
      rate: [],
      safRate: [],
      envRate: [],
      yearUrl: '',
      accident: {
        startYmd: '',
        endYmd: '',
      },
      grid1: {
        listUrl: '',
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'workSummary',
            field: 'workSummary',
            label: '작업개요',
            align: 'left',
            sortable: false,
          },
          {
            name: 'swpStepName',
            field: 'swpStepName',
            label: '진행단계',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          // {
          //   name: 'permitDate',
          //   field: 'permitDate',
          //   label: '허가일',
          //   align: 'center',
          //   sortable: false,
          // },
          {
            name: 'permitTypeName',
            field: 'permitTypeName',
            label: '허가서구분',
            style: 'width:100px',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        listUrl: '',
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'ibmTaskTypeName',
            field: 'ibmTaskTypeName',
            label: '업무',
            align: 'center',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:250px',
            sortable: false,
          },
          {
            name: 'ibmStepName',
            field: 'ibmStepName',
            label: '진행단계',
            align: 'center',
            sortable: false,
          },
          {
            name: 'actionCompleteRequestDate',
            field: 'actionCompleteRequestDate',
            label: '조치완료 요청일',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      sop4mClassItems: [],
      occurYear: '',
      rateUrl: '',
      wastelistUrl: '',
      airlistUrl: '',
      patrolUrl: '',
      eduAttendUrl: '',
      workPermitUrl: '',
      imprProgressUrl: '',
      workProgressUrl: '',
      eduCompleteUrl: '',
      eduYear: '',
      imprYear: '',
      workProgressList: [],
      showTooltopCnt: 0,
      showTooltop: [false,false,false,false,false,false,false,false],
      iconItems: ['school','settings_applications','build','build_circle','restore','manage_accounts','report','report_problem'],
      colorItems: ['primary','secondary','amber-9','deep-orange','secondary','brown-5','purple','green-7',],
      airList: [],
      allCntList: [],
      wasteComboItems2: [],
      plantList: [],
      accidentCdList: [],
    };
  },
  computed: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.showTooltopCnt = 0
      this.yearUrl = selectConfig.sop.iim.accident.status.year.url;
      this.rateUrl = selectConfig.main.imprChart.url;
      this.patrolUrl = selectConfig.main.patrolChart.url;
      this.workPermitUrl = selectConfig.main.workPermitStatus.url;
      this.imprProgressUrl = selectConfig.main.imprProgress.url;
      this.workProgressUrl = selectConfig.main.workProgress.url;
      this.eduAttendUrl = selectConfig.main.eduAttendees.url;
      this.eduCompleteUrl = selectConfig.main.eduComplete.url;
      this.airlistUrl = selectConfig.main.airChart.url;
      this.wastelistUrl = selectConfig.env.waste.volume.uc.url + '/main';

      // 년도 설정
      let years = [];
      for (let i = 0; i < 3; i++) {
        years.splice(0, 0, this.$comm.getPrevYear(i));
      }

      this.accident.startYmd = years[0];
      this.accident.endYmd = years[0];

      this.$comm.getComboItems('SOP_4M_CLASS_CD').then(_result => {
        this.sop4mClassItems = _result
      });
      this.$comm.getComboItems('PLANT_CD').then(_result => {
        // this.plantList = _result
        this.plantList = this.$_.reject(_result, { code: '05' });
        this.getYearList();
        
        this.getWorkPermits();
        setTimeout(() => {
          this.getAirchart();
        }, 800);
        setTimeout(() => {
          this.getWasteType();
        }, 1600);
        setTimeout(() => {
          this.getImprStatus();
        }, 2400);
        // this.getImprProgress();
        // this.getWorkProgress();
        setTimeout(() => {
          this.getEduList();
        }, 3200);
        // this.intervalTooltip1();
      });
    },
    getWasteType() {
      this.$http.url = selectConfig.env.waste.mst.list.url;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.request((_result) => {
        this.wasteComboItems2 = _result.data;
        this.getWasteList();
      },);
    },
    getWorkProgress() {
      this.$http.url = this.workProgressUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: this.plantCd1
      }
      this.$http.request((_result) => {
        this.workProgressList = _result.data
      },);
    },
    getWorkPermits() {
      this.$http.url = this.workPermitUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: this.plantCd2,
      };
      this.$http.request((_result) => {
        this.grid1.data = _result.data
      },);
    },
    getImprProgress() {
      this.$http.url = this.imprProgressUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd3,
      };
      this.$http.request((_result) => {
        this.grid2.data = _result.data
      },);
    },
    getAirchart() {
      this.$http.url = this.airlistUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        // plantCd: this.plantCd5,
        // airInspectTypeCd: this.airInspectTypeCd,
        measureYear: this.measureYear,
      };
      let rate = [];
      this.$http.request((_result) => {
        this.airList = this.$_.clone(_result.data);
        let taskIdx = 0;
        this.$_.forEach(_result.data, task => {
          // task.plantName = task.plantName + '(총' + task.allCnt + '건)'
          this.$_.forEachRight(this.airChart.series, () => {
            if (!rate[taskIdx] && (task.innerCnt + task.legalCnt) > 0) {
              rate[taskIdx] = (task.innerCnt + task.legalCnt) > 0 ?
                String(this.$_.round((task.innerCnt + task.legalCnt)/task.allCnt, 3)) + '%' : '0%';
            } else if (task.innerCnt + task.legalCnt === 0) {
              rate[taskIdx] = '0%'
            }
          })
          taskIdx++;
        })
        this.airChart.series[0].data = this.$_.map(_result.data, 'innerCnt')
        this.airChart.series[1].data = this.$_.map(_result.data, 'legalCnt')

        let xaxis = this.$_.map(_result.data, 'plantName');
        let annotations = [];
        rate.forEach((r, idx) => {
          // xaxis[idx] += (r ? '(' + r + ')' : '');
          annotations[idx] = {
            x: xaxis[idx],
            strokeDashArray: 0, 
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
              // text: r ? '이행률 : ' + r : '',
            }
          }
        })
        xaxis.forEach((x, idx) => {
          if (!annotations[idx]) {
            annotations[idx] = {
              x: x,
              strokeDashArray: 0,
              borderColor: '#EEEEEE',
              borderWidth: 0,
              // borderColor: '#775DD0',
              label: {
                borderColor: '#775DD0',
                orientation: 'horizontal',
                style: {
                  color: '#fff',
                  fontSize: '12px',
                  background: '#775DD0',
                },
                text: '',
              }
            }
          }
        })
        this.airChart.chartOptions.xaxis.categories = xaxis;
        this.airChart.chartOptions.annotations.xaxis = annotations;

        this.airChart.chartWidth = '100%';
        this.setChart('airChart', 800);
      },);
    },
    getYearList() {
      this.$http.url = this.yearUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        occurYear: this.occurYear,
      }
      this.$http.request((_result) => {
        this.yearOcuurChart.series = [];

        let xaxis = this.$_.map(this.plantList, 'codeName');
        this.yearOcuurChart.chartOptions.xaxis.categories = xaxis;
        let seriesData = this.$_.map(_result.data, 'accidentTypeName');

        seriesData = seriesData.filter((element, index) => {
          return seriesData.indexOf(element) === index;
        })

        seriesData.forEach(_item => {
          this.yearOcuurChart.series.push({
            name: _item,
            data: Array.from({length : xaxis.length}, () => 0),
          });
        })
        
        this.$_.forEach(_result.data, _item => {
          let idx = this.$_.findIndex(this.yearOcuurChart.series, {name: _item.accidentTypeName})
          let idx2 = xaxis.indexOf(_item.plantName)
          
          this.yearOcuurChart.series[idx].data[idx2] += Number(_item.yearCount)

          this.accidentCdList.push({
            code: _item.accidentTypeCd,
            codeName: _item.accidentTypeName,
          });
        })

        this.setChart('yearOcuurChart', 400);
      },);
    },
    getWasteList() {
      if (this.wasteYear !== null) {
        this.$http.url = this.wastelistUrl;
        this.$http.type = 'GET';
        this.$http.isLoading = false;
        this.$http.param = {
          wasteYear: this.wasteYear,
        };
        this.$http.request((_result) => {
          let sdata = [];
          this.wasteTitle = '폐기물발생 추이분석';
          if (this.wasteCode == '1') {
            this.$set(this.wasteChart.chartOptions.title, 'text', '처리량(kg) / 생산량(ton)');
            sdata = this.$_.filter(_result.data, {wasteType : this.wasteCode, envWasteMstId: this.envWasteMstId });
          } else {
            if (this.wasteCode == '2') {
              this.$set(this.wasteChart.chartOptions.title, 'text', '처리비(원) / 생산량(kg)');
            } else {
              this.$set(this.wasteChart.chartOptions.title, 'text', '매각수익(원) / 생산량(kg)');
            }
            sdata = this.$_.filter(_result.data, {wasteType : this.wasteCode });
          }
          this.wasteChart.series = [];
        
          this.$_.forEach(this.plantList, _plant => {
            let _data = [];
            
            this.$_.forEach(sdata, item => {
              if (_plant.code === item.plantCd) {
                _data = [item.tv01,item.tv02,item.tv03,item.tv04,item.tv05,item.tv06,item.tv07,item.tv08,item.tv09,item.tv10,item.tv11,item.tv12]
              }
            })

            if (_data.length == 0) {
              _data = [0,0,0,0,0,0,0,0,0,0,0,0];
            }

            this.wasteChart.series.push({
              plantCd: _plant.code,
              name: _plant.codeName,
              data: _data
            })
          });

          this.setChart('wasteChart', 1200);
        },);
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message:
          '기준년도를 선택하세요',
          type: 'warning', // success / info / warning / error
        });
      }
    },
    getEduList() {
      this.$http.url = this.eduCompleteUrl;
      this.$http.isLoading = false;
      this.$http.type = 'GET';
      this.$http.param = {
        eduYear: this.eduYear,
      };
      this.$http.request((_result) => {
        let rate = [];
        let xaxis = [];
        this.eduChart.series[0].data = [];
        this.eduChart.series[1].data = [];
        this.eduChart.series[2].data = [];
        this.$_.forEach(_result.data, chartData => {
          this.eduChart.series[0].data.push(chartData.shCompleteCnt);
          this.eduChart.series[0].data.push(chartData.ecompleteCnt);
          this.eduChart.series[0].data.push(chartData.ocompleteCnt);
          this.eduChart.series[1].data.push(chartData.shNoCompleteCnt);
          this.eduChart.series[1].data.push(chartData.enoCompleteCnt);
          this.eduChart.series[1].data.push(chartData.onoCompleteCnt);
          this.eduChart.series[2].data.push(chartData.shTempCnt);
          this.eduChart.series[2].data.push(chartData.etempCnt);
          this.eduChart.series[2].data.push(chartData.otempCnt);
          let shtotalComplete = chartData.shCompleteCnt + chartData.shNoCompleteCnt + chartData.shTempCnt;
          let shcomplete = shtotalComplete ? String(this.$_.round((chartData.shCompleteCnt / shtotalComplete) * 100)) + '%' : '0%';
          let etotalComplete = chartData.ecompleteCnt + chartData.enoCompleteCnt + chartData.etempCnt;
          let ecomplete = etotalComplete ? String(this.$_.round((chartData.ecompleteCnt / etotalComplete) * 100)) + '%' : '0%';
          let ototalComplete = chartData.ocompleteCnt + chartData.onoCompleteCnt + chartData.otempCnt;
          let ocomplete = ototalComplete ? String(this.$_.round((chartData.ocompleteCnt / ototalComplete) * 100)) + '%' : '0%';
          rate = this.$_.concat(rate, [shcomplete, ecomplete, ocomplete])
          xaxis = this.$_.concat(xaxis, ['안전보건,' + chartData.plantName, '환경,' + chartData.plantName, '기타,' + chartData.plantName])
        })
        
        let groups = this.$_.map(_result.data, 'plantName');
        let annotations = [];
        rate.forEach((r, idx) => {
          annotations[idx] = {
            x: xaxis[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
            }
          }
        })
        this.eduChart.chartOptions.xaxis.group.groups = this.$_.map(groups, group => {
          return {
            title: group, cols: 3
          }
        });
        this.eduChart.chartOptions.xaxis.categories = xaxis;
        this.eduChart.chartOptions.annotations.xaxis = annotations;

        this.eduChart.chartWidth = '100%';
        this.setChart('eduChart', 2000);
      },);
    },
    setChart(_target) {
      if (this.$refs[_target]) {
        console.log(_target, ' : ', this.$refs[_target])
        this.$refs[_target].refresh();
      }
    },
    getImprStatus() {
      this.$http.url = this.rateUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: this.plantCd4,
        imprYear: this.imprYear,
      }
      this.rate = [];
      this.$http.request((_result) => {
        let series1 = this.$_.filter(_result.data, { ibmTaskTypeCd: 'ITT0000135' }) // 환경
        let series2 = this.$_.filter(_result.data, { ibmTaskTypeCd: 'ITT0000060' }) // 안전보건
        this.$set(this.imprChart1, 'series', [
          {
            name: '조치중',
            data: this.$_.map(series1, 'actioning')
          },
          {
            name: '개선완료(총합)',
            data: this.$_.map(series1, 'complete')
          },
          {
            name: '지연 건수',
            data: this.$_.map(series1, 'overAction')
          },
        ])
        this.$set(this.imprChart2, 'series', [
          {
            name: '조치중',
            data: this.$_.map(series2, 'actioning')
          },
          {
            name: '개선완료(총합)',
            data: this.$_.map(series2, 'complete')
          },
          {
            name: '지연 건수',
            data: this.$_.map(series2, 'overAction')
          },
        ])
        let rate1 = [];
        let rate2 = [];
        this.$_.forEach(series1, item => {
          rate1.push(item.requestTotal > 0 ? String(this.$_.floor((item.complete / item.requestTotal) * 100)) + '%' : '')
        })
        this.$_.forEach(series2, item => {
          rate2.push(item.requestTotal > 0 ? String(this.$_.floor((item.complete / item.requestTotal) * 100)) + '%' : '')
        })
        let xaxis1 = this.$_.map(series1, 'gubun');
        let xaxis2 = this.$_.map(series2, 'gubun');
        let annotations1 = [];
        let annotations2 = [];
        rate1.forEach((r, idx) => {
          annotations1[idx] = {
            x: xaxis1[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
            }
          };
        });
        rate2.forEach((r, idx) => {
          annotations2[idx] = {
            x: xaxis2[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
            }
          };
        });

        this.imprChart1.chartOptions.xaxis.categories = xaxis1;
        this.imprChart2.chartOptions.xaxis.categories = xaxis2;
        this.imprChart1.chartOptions.annotations.xaxis = annotations1;
        this.imprChart2.chartOptions.annotations.xaxis = annotations2;
        
        this.imprChart1.chartWidth = '100%';
        this.imprChart2.chartWidth = '100%';

        this.setChart('imprChart1', 1600);
        this.setChart('imprChart2', 1600);
      },);
    },
    getEduIcon(_code) {
      let returntext = '';
      switch(_code) {
        case 'EKFC000001': // 안전보건
          returntext = 'engineering';
          break;
        case 'EKFC000002': // 환경
          returntext = 'public';
          break;
        default: // 그외
          returntext = 'school';
          break;
      }
      return returntext;
    },
    getEduColor(_code) {
      let returntext = '';
      switch(_code) {
        case 'EKFC000001': // 안전보건
          returntext = 'blue-6';
          break;
        case 'EKFC000002': // 환경
          returntext = 'orange-6';
          break;
        default: // 그외
          returntext = 'grey-7';
          break;
      }
      return returntext;
    },
    goPage(_title, _page, _period, _plantCd) {
      if (typeof _period === 'string') {
        this.popupOptions.param = {
          mainPeriod: _period === undefined ? '' : _period,
          mainPlantCd: _plantCd === undefined ? '' : _plantCd,
        };
      } else {
        this.popupOptions.param = {
          mainPeriod: _period === undefined ? [] : _period,
          mainPlantCd: _plantCd === undefined ? '' : _plantCd,
        };
      }
      this.popupOptions.title = _title;
      this.popupOptions.width = '90%';
      this.popupOptions.target = () => import(`@/pages${_page}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    grid1Click(_row) {
      this.popupOptions.title = '작업허가서';
      this.popupOptions.width = '90%';
      this.popupOptions.isFull = true;
      this.popupOptions.param = {
        sopWorkPermitId: _row ? _row.sopWorkPermitId : '',
        permitTypeCd: _row ? _row.permitTypeCd : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/swp/safeWorkPermitDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    // eduClick(_eduCourseId) {
    //   this.popupOptions.title = "교육 과정 상세"; // 교육 과정 상세
    //   this.popupOptions.width = '90%';
    //   this.popupOptions.isFull = true;
    //   this.popupOptions.param = {
    //     eduCourseId: _eduCourseId ? _eduCourseId : '',
    //   };
    //   this.popupOptions.target = () => import(`${"@/pages/sop/edu/cc/educationCurriculumDetail.vue"}`);
    //   this.popupOptions.visible = true;
    //   this.popupOptions.closeCallback = this.closePopup;
    // },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    goPageMap(_plantCd) {
      this.popupOptions.width = '60%';
      this.popupOptions.title = "작업허가 MAP";
      this.popupOptions.param = {
        mainPlantCd: _plantCd ? (_plantCd.indexOf(',') > -1 ? null : _plantCd) : null,
      };
      this.popupOptions.target = () => import(`${'./indexMap.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    selectedBar(e, chart, opts) {
      let idx = this.$_.findIndex(this.plantList, {codeName: opts.w.config.annotations.xaxis[opts.dataPointIndex].x})
      this.popupOptions.width = '70%';
      this.popupOptions.title = "대기 추이분석(법적기준/내부기준) 상세";
      this.popupOptions.param = {
        plantCd: this.plantList[idx].code,
        measureYear: this.measureYear ? this.measureYear : null,
      };
      this.popupOptions.target = () => import(`${'./indexAir.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    selectedBaryearOcuurChart(e, chart, opts) {
      let idx = this.$_.findIndex(this.plantList, {codeName: opts.w.config.xaxis.categories[opts.dataPointIndex]})
      this.popupOptions.width = '90%';
      this.popupOptions.title = "안전사고현황";
      this.popupOptions.param = {
        plantCd: this.plantList[idx].code,
        accidentTypeCd: this.$_.filter(this.accidentCdList, { codeName: opts.w.config.series[opts.seriesIndex].name })[0].code,
        period: [this.occurYear + '-01-01', this.occurYear + '-12-31']
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/iim/processAccident.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    selectedBarImp(event, chartContext, opts, flag) {
      let stepGubun = '';
      switch (opts.w.config.series[opts.seriesIndex].name) {
        case '조치중':
          stepGubun = 'actioning'
          break;
        case '개선완료(총합)':
          stepGubun = 'complete'
          break;
        case '지연 건수':
          stepGubun = 'overAction'
          break;
        default:
          break;
      }
      let sop4mClassCd = '';
      if (flag === 'SAFETYHEALTH') {
        sop4mClassCd = this.$_.find(this.sop4mClassItems, { codeName: opts.w.config.xaxis.categories[opts.dataPointIndex] }).code
      }
      this.popupOptions.width = '90%';
      this.popupOptions.title = "개선목록 (업무별 현황)";
      this.popupOptions.param = {
        plantCd: this.plantCd4,
        ibmTaskTypeCd: flag === 'SAFETYHEALTH' ? 'ITT0000060' : 'ITT0000135',
        actionCompleteRequestDates: [this.imprYear + '-01-01', this.imprYear + '-12-31'],
        patrolGubun: flag,
        year: this.imprYear,
        itemGubun: opts.w.config.xaxis.categories[opts.dataPointIndex],
        stepGubun: stepGubun,
        sop4mClassCd: sop4mClassCd,
        isMain: true,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/impr.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    selectedBarEdu(e, chart, opts) {
      let idx = this.$_.findIndex(this.plantList, {codeName: opts.w.config.xaxis.group.groups[Math.floor(opts.dataPointIndex / 3)].title})
      this.popupOptions.width = '90%';
      this.popupOptions.title = "교육현황 (사업장별 전체현황)";
      this.popupOptions.param = {
        plantCd: this.plantList[idx].code,
        period: [this.eduYear + '-01-01', this.eduYear + '-12-31'],
        state: opts.w.config.series[opts.seriesIndex].name, // 완료, 미완료, 진행중
        educationKindCdLargeName: this.$_.split(opts.w.config.xaxis.categories[opts.dataPointIndex], ',')[0]
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/edu/result/educationResultPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
  }
};
</script>
<style lang="sass">
  .cardcontents
    margin-top: 6px
    margin-bottom: 6px
    margin-right: 6px
    border-radius: 10px !important
    .card-body
      padding: 10px !important
    .card-header:before
      font-family: "Material Icons"
      content: "\e876"
    .card-header
      height: 40px
      color: #00a1b9
      background: #f8f8f8
      display: inline-block
      border-radius: 10px 10px 0 0 !important
      padding-top: 8px
      .card-more
        float: right !important
        cursor: pointer
        color: #4DB6AC
.card-more-txt
  font-size:12px
  margin-top: 3px
.main-header-input
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.main-header-input2
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.cardcontents .card-body.nopadgrid
  padding-top: 0px !important
.btn-fixed-width-height
  width: 95%
  margin: 3px !important
  // pointer-events: none
.attendBoxCnt
  background: #f44336
  margin-left: 10px
  color: #fff
  padding: 2px 8px 2px 8px
  border-radius: 7px
.accidentMove
  position: absolute
  top: 10px
  right: 20px
  cursor: pointer



</style>
<style>
.director-main-board path[val="0"] {
  fill: none !important;
  stroke: none !important;
}
</style>